import { buildBindable } from '@monofe/di';
import type { ISettingsStorage } from '../interface';
import {
    bindSettingsStorage,
    injectSettingsStorage,
    unbindSettingsStorage,
} from '../interface/settingsStorage';
import TYPES from '../interface/types';
const loader = import('./settingsStorage');

async function _build(): Promise<Readonly<ISettingsStorage>> {
    const module = await loader;
    return module.default();
}

export default buildBindable<ISettingsStorage>({
    id: TYPES.ISettingsStorage,
    bind: bindSettingsStorage,
    remove: unbindSettingsStorage,
    inject: injectSettingsStorage,
    build: _build,
});
